import React from 'react';
import StatusBadge from '../../../components/ui/StatusBadge';
import {
  AGENT_STATUS_SHORT_LABELS,
  getStatusIcon,
} from '../../../support/iconMappings';

const AGENT_STATUS_STYLES = {
  active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  inactive: 'bg-slate-100 text-slate-600 border-slate-200',
};

function AgentStatusBadge({ status, compact = false }) {
  const label = AGENT_STATUS_SHORT_LABELS[status] || status;
  const style = AGENT_STATUS_STYLES[status] || AGENT_STATUS_STYLES.inactive;
  const Icon = getStatusIcon('agent', status);

  return (
    <StatusBadge
      label={label}
      styleClass={style}
      icon={Icon}
      compact={compact}
    />
  );
}

export default AgentStatusBadge;
